import React from 'react'
import '../../css/component/freeLecture/FreeLectureCardSkeleton.css'

class SkeletonItem extends React.Component{
    render() {
        return (
            <div className="skeleton">
                <div className="skeleton-head"></div>
                <div className="skeleton-body">
                    <div className="skeleton-title"></div>
                    <div className="skeleton-content"></div>
                </div>
            </div>
        )
    }
}

class FreeLectureCardSkeleton extends React.Component {
    static defaultProps = {
        num: 1,
    };

    constructor() {
        super();
        this.state = {
            list: null
        }
    }

    componentDidMount() {
        let list = new Array(this.props.num).fill(null)
        this.setState({
            list: list
        })
    }

    render() {
        return (
            <div className="FreeLectureCardSkeleton">
            {this.state.list &&
                this.state.list.map((item, index) => <SkeletonItem key={index} />)
            }
            </div>
        )
    }
}

export default FreeLectureCardSkeleton


// WEBPACK FOOTER //
// ./src/components/freeLecture/FreeLectureCardSkeleton.js